export default __webpack_public_path__ + "static/media/logo.1922e490.svg";